export const SwitchPublicShareApi = Symbol('SwitchPublicShareApi');
